import { useRef, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { useAssetsValue } from "../../context/reducers/assetsContext";
import { setFolder } from "../../context/fetch/fetchAssets";
import { useNavigate } from "react-router-dom";
import FolderList from "./FolderList";
import Spinner from "../../editor/core/Spinner";
import { Button, Form } from "react-bootstrap";

const PreviewFolder = (props) => {
  const [state, dispatch] = useAssetsValue();
  const [showNewFolderInput, setShowNewFolderInput] = useState(false);
  const newFolderNameRef = useRef(null);
  const navigate = useNavigate();

  const handleOnNewFolderClick = () => {
    setShowNewFolderInput(true);
  };

  const handleSaveNewFolder = () => {
    const name = newFolderNameRef.current.value.trim();
    if (name) {
      setFolder(name, dispatch, navigate, props, null);
      setShowNewFolderInput(false);
    }
  };

  const handleCancelNewFolder = () => {
    setShowNewFolderInput(false);
  };

  return (
    <div className={"folder-editor "}>
      <div className="folder-btn-group text-end">
        <Button onClick={handleOnNewFolderClick} className={"add-btn btn btn-dark"}>
          <FiPlus size={16} />
          New folder
        </Button>
      </div>
      <div>
        {showNewFolderInput && (
          <div className="new-folder-input-wrapper">
            <Form
              className="d-flex align-items-center gap-1 subfolder-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSaveNewFolder();
              }}
            >
              <Form.Control
                type="text"
                placeholder="Folder name"
                ref={newFolderNameRef}
                maxLength={30}
                autoFocus
                className="folder-edit-input"
              />
              <Button type="submit" variant="outline-info" size="sm" className="no-underline">
                Save
              </Button>
              <Button variant="outline-info" size="sm" className="no-underline" onClick={handleCancelNewFolder}>
                X
              </Button>
            </Form>
          </div>
        )}
        {state.folder.isFolderLoading && !state.folder.list.length && (
          <Spinner style={{ color: "#17bae7" }} />
        )}
        {state.folder.list?.map((folder) => (
          <FolderList key={folder.id} folder={folder} {...props} />
        ))}
      </div>
    </div>
  );
};

export default PreviewFolder;
